// Eski İngilizce panel adresleri (yer imleri, SMS/e-postayla gönderilmiş bağlantılar, ör. `/control/compliance`,
// `/business/reports?from=…`, `/share/<token>`) Türkçe karşılığına çevrilir; App bilinmeyen her adreste önce buna bakar.
// Saf fonksiyon (birim testli): yalnız yol çevrilir, arama ve # parçasını çağıran korur.
import { REPORT_SLUG } from './paths';

/** Üst düzey eski yol → yeni kök. Bunların altındaki parça (paylaşım anahtarı vb.) olduğu gibi kalır. */
const TOP = new Map<string, string>([
  ['control', 'operasyon'],
  ['business', 'kurum'],
  ['share', 'paylasim'],
  ['login', 'giris'],
  ['impersonate', 'destek-girisi'],
  ['dev', 'gelistirici'],
]);

/** Panel alt yol sözlüğü: iç içe yollarda da aynen uygulanır (kimlikler sözlükte olmadığı için değişmez). */
export const SEGMENTS = new Map<string, string>([
  ['alerts', 'uyarilar'],
  ['announcements', 'duyurular'],
  ['history', 'gecmis'],
  ['new', 'yeni'],
  ['edit', 'duzenle'],
  ['editor', 'duzenle'],
  ['audit-log', 'denetim-kaydi'],
  ['complaints', 'sikayetler'],
  ['compliance', 'belge-uyumu'],
  ['expiring', 'suresi-dolanlar'],
  ['contracts', 'sozlesmeler'],
  ['customers', 'musteriler'],
  ['devices', 'cihazlar'],
  ['stickers', 'etiketler'],
  ['drivers', 'soforler'],
  ['documents', 'belgeler'],
  ['performance', 'performans'],
  ['employees', 'calisanlar'],
  ['finance', 'finans'],
  ['billing', 'faturalama'],
  ['driver-payments', 'sofor-odemeleri'],
  ['extras', 'ek-ucretler'],
  ['invoices', 'faturalar'],
  ['guides', 'rehberler'],
  ['integrations', 'entegrasyonlar'],
  ['live', 'canli'],
  ['maintenance', 'bakim'],
  ['optimization', 'optimizasyon'],
  ['compare', 'karsilastir'],
  ['recommendation', 'oneri'],
  ['passengers', 'yolcular'],
  ['groups', 'gruplar'],
  ['import', 'ice-aktar'],
  ['privacy', 'gizlilik'],
  ['proposals', 'teklifler'],
  ['comments', 'yorumlar'],
  ['share', 'paylas'],
  ['quality', 'kalite'],
  ['ratings', 'puanlar'],
  ['reports', 'raporlar'],
  ['requests', 'talepler'],
  ['heatmap', 'isi-haritasi'],
  ['routes', 'rotalar'],
  ['versions', 'surumler'],
  ['satisfaction', 'memnuniyet'],
  ['settings', 'ayarlar'],
  ['branding', 'marka'],
  ['company', 'firma'],
  ['notifications', 'bildirimler'],
  ['trip-rules', 'sefer-kurallari'],
  ['students', 'ogrenciler'],
  ['subscription', 'abonelik'],
  ['upgrade', 'yukselt'],
  ['usage', 'kullanim'],
  ['team', 'ekip'],
  ['invite', 'davet'],
  ['roles', 'roller'],
  ['trips', 'seferler'],
  ['intervene', 'mudahale'],
  ['users', 'kullanicilar'],
  ['vehicles', 'araclar'],
  // raporlar: `/control/reports/on-time` → `/operasyon/raporlar/zamaninda-varis`
  ...Object.entries(REPORT_SLUG),
]);

/** Eski İngilizce yolu Türkçe yola çevirir; eski bir panel yolu değilse null döner. */
export function translateLegacyPath(pathname: string): string | null {
  const [, top = '', ...rest] = pathname.split('/');
  const root = TOP.get(top);
  if (!root) return null;
  let tail: string[];
  if (top === 'control' || top === 'business') tail = rest.map((s) => SEGMENTS.get(s) ?? s);
  else if (top === 'dev') tail = rest.map((s, i) => (i === 0 && s === 'gallery' ? 'galeri' : s));
  else tail = rest;
  return ['', root, ...tail].join('/');
}
